import { render, staticRenderFns } from "./AllLogsView.vue?vue&type=template&id=c3224a78&scoped=true&"
import script from "./AllLogsView.vue?vue&type=script&lang=js&"
export * from "./AllLogsView.vue?vue&type=script&lang=js&"
import style0 from "./AllLogsView.vue?vue&type=style&index=0&id=c3224a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3224a78",
  null
  
)

export default component.exports